import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { lelandConfig } from "./data";

export default function LelandPage() {
  return <CityPageTemplate config={lelandConfig} />;
}